<style lang="scss">
  #modal-add-owner {
    .modal-body {
      display: none;
    }
  }
</style>

<template>
  <BModal
    id="modal-add-owner"
    ref="modal-add-owner"
    hide-body="hide-body"
    footer-class="justify-content-end"
  >
    <template slot="modal-header">
      <h4
        class="modal-title"
        v-if="lead.name"
      >
        {{ __('Já existe um lead com o e-mail') }}<br>{{ lead.email }}
      </h4>
      <button
        class="close"
        type="button"
        aria-label="Close"
        @click="close()"
      >
        <span aria-hidden="true">×</span>
      </button>
    </template>
    <template slot="modal-footer">
      <!-- If private and user doesnt have it -> button to add-->
      <!-- otherwiser, button to see it-->
      <button
        class="btn btn-box-success m-b-10"
        type="submit"
        @click.prevent="save()"
        v-if="lead.is_private && !lead.has_user"
      >
        {{ __('Adicionar') }}<span v-if="lead.first_name">{{ lead.first_name }}</span>{{ __('aos meus leads') }}
      </button>
      <button
        class="btn btn-box-success m-b-10"
        type="submit"
        @click.prevent="go()"
        v-else
      >
        {{ __('Visualizar') }}
      </button>
      <button
        class="btn btn-box m-b-10 float-right"
        type="submit"
        @click.prevent="close()"
      >
        {{ __('Cancelar') }}
      </button>
    </template>
  </BModal>
</template>

<script>
import { BModal } from 'bootstrap-vue';

export default {
  components: {
    BModal,
  },

  props: ['user'],

  mounted () {
    Bus.$on('addLeadOwnerButtonTrigger', (lead) => {
      this.lead = lead;
      this.$nextTick(() => {
        this.open();
      });
    });
  },

  data () {
    return {
      lead: {},
      saving: false,
    };
  },

  methods: {
    open () {
      this.$refs['modal-add-owner'].show();
    },

    close () {
      this.$refs['modal-add-owner'].hide();
    },

    go () {
      window.open(`/lead/${this.lead.hashid}`);
    },

    save () {
      this.$http.put(`/lead/${this.lead.hashid}`, { owner: this.user.id })
        .then(() => {
          window.location = `/lead/${this.lead.hashid}`;
        })
        .catch((error) => console.log(error));
    },
  },
};
</script>
